import { observable, computed, action } from 'mobx';
import { inject } from 'mobx-react';
import { Product, Notification as INotification } from '../models/interfaces';
import { API_URL } from '../constants/constants';
import { NOTIFICATION_STORE } from '../constants/constants';
import { NotificationStore } from './NotificationStore';
import { CompanyStore } from './CompanyStore';

export class ProductStore {
  @observable
  public products: Array<Product>;

  public hasError: boolean;
  public notificationStore: NotificationStore;
  public companyStore: CompanyStore;

  @observable
  public textFilter: string;

  @observable
  public brandFilter: string;

  @observable
  public productFilter: boolean;

  @observable
  public marketingMaterialFilter: string;

  @observable
  public requesting: boolean;

  @observable
  public totalWeight: string;

  constructor(
    initial: Product[],
    notificationStore: NotificationStore,
    companyStore: CompanyStore
  ) {
    this.products = initial;
    this.hasError = false;
    this.notificationStore = notificationStore;
    this.textFilter = '';
    this.brandFilter = '';
    this.companyStore = companyStore;
    this.requesting = false;
    this.marketingMaterialFilter = '';
    this.totalWeight = '';
  }

  @computed
  get allProducts() {
    return this.products;
  }

  @computed
  get filteredProducts() {
    if (
      !this.textFilter &&
      !this.brandFilter &&
      !this.productFilter &&
      this.marketingMaterialFilter === ''
    ) {
      return this.products;
    }

    let products: Product[] = this.products;

    if (this.textFilter) {
      products = products.filter((product) => {
        return (
          product.Description.toLowerCase().includes(
            this.textFilter.toLowerCase()
          ) ||
          product.ItemNo.toLowerCase().includes(this.textFilter.toLowerCase())
        );
      });
    }

    if (this.brandFilter) {
      products = products.filter((product) => {
        if (product.Description) {
          return product.Description.toLowerCase().includes(
            this.brandFilter.toLowerCase()
          );
        }
        return false;
      });
    }

    if (this.productFilter) {
      const ignore = ['MESS', 'KAMP', 'MARKK'];
      products = products.filter((product) => {
        // Should work same way as in Array.includes works, but typescript hates array.includes
        return ignore.indexOf(product.ItemCategoryCode) === -1;
      });
    }

    if (this.marketingMaterialFilter !== '') {
      products = products.filter((product) => {
        return product.ItemCategoryCode === this.marketingMaterialFilter;
      });

      return products;
    }

    return products;
  }

  @computed
  get weight() {
    return this.totalWeight;
  }

  @action
  setTotalWeight(weight: string) {
    this.totalWeight = weight;
  }

  async fetchProducts() {
    this.requesting = true;
    this.products = [];
    const token = localStorage.getItem('token');
    const company = this.companyStore.selectedCompany;
    const url = `${API_URL}/v1/products?company=${company}`;
    const payload = { type: 'getAllProducts', company: company };

    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    const data = await fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include',
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        this.hasError = true;

        const error = {
          type: 'error',
          message: err.message + ': Tuotteita ei voitu hakea',
          seen: false,
        };

        this.notificationStore.addNotification(error);

        return err;
      });

    if (this.hasError) {
      // @TODO Show error message to user.
    } else if (data.status) {
      this.notificationStore.addNotification({
        type: 'error',
        message: 'Virhe taustajärjestelmässä: ' + data.errors.join(),
        seen: false,
      });
    } else {
      const products: Array<Product> = await data.NAVItem;

      // BLACKLISTED PRODUCTS, NOT YET SOLD. REMOVE THIS WHEN ANNE SAYS SO
      const blackListedProducts: Array<string> = [];

      this.products = products.filter((p) => {
        if (!p) {
          return false;
        }

        if (!p.Description) {
          return false;
        }

        return blackListedProducts.find((a) => {
          return a === p.ItemNo;
        })
          ? false
          : true;
      });
    }
    this.requesting = false;
  }
}

export default ProductStore;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/ProductStore.ts